import { Reducer } from 'redux';
import { UserIpsState, UserIpsTypes } from './types';

const INITIAL_STATE: UserIpsState = {
  userIpData: {
    id: '',
    name: '',
    start: '',
    end: '',
    type: 0,
    owner: '',
    UserIps: [],
    createdAt: '',
    updatedAt: '',
  },
  userIpsList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<UserIpsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST USER IPS
    case UserIpsTypes.LIST_USER_IPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userIpsList: INITIAL_STATE.userIpsList,
      };
    case UserIpsTypes.LIST_USER_IPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        userIpsList: action.payload.userIpsList,
      };
    case UserIpsTypes.LIST_USER_IPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userIpsList: INITIAL_STATE.userIpsList,
      };

    // CASES GET USER IP
    case UserIpsTypes.GET_USER_IP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userIpData: INITIAL_STATE.userIpData,
      };
    case UserIpsTypes.GET_USER_IP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userIpData: action.payload.userIpData,
      };
    case UserIpsTypes.GET_USER_IP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userIpData: INITIAL_STATE.userIpData,
      };

    // CASES FILTER USER IPS
    case UserIpsTypes.FILTER_USER_IPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userIpsList: INITIAL_STATE.userIpsList,
      };
    case UserIpsTypes.FILTER_USER_IPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        userIpsList: action.payload.userIpsList,
      };
    case UserIpsTypes.FILTER_USER_IPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userIpsList: INITIAL_STATE.userIpsList,
      };

    // CASES CREATE USER IP
    case UserIpsTypes.CREATE_USER_IP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UserIpsTypes.CREATE_USER_IP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UserIpsTypes.CREATE_USER_IP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES CREATE LIST USER IP
    case UserIpsTypes.CREATE_LIST_USER_IPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UserIpsTypes.CREATE_LIST_USER_IPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UserIpsTypes.CREATE_LIST_USER_IPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES UPDATE USER IP
    case UserIpsTypes.UPDATE_USER_IP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UserIpsTypes.UPDATE_USER_IP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UserIpsTypes.UPDATE_USER_IP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES DELETE USER IP
    case UserIpsTypes.DELETE_USER_IP_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UserIpsTypes.DELETE_USER_IP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case UserIpsTypes.DELETE_USER_IP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export default reducer;
